import React from "react";
import Icon from "../../../../common/components/Icon/Icon";
import { IconSet, IconSetIds } from "../../../../common/components/Icon/IconMap";
import cx from "classnames";
import styles from "./IconLibrary.module.scss";

const IconLibrary: React.FC = () => {
    return (
        <div className={cx(styles["container"])}>
            {Object.keys(IconSet).map((key: IconSetIds) => {
                return (
                    <div
                        key={key}
                        className={cx(styles["card"], "layout-flex-column--centred")}>
                        <Icon id={key} className={styles["icon"]} />
                        <span>{key}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default IconLibrary;
